import { render, staticRenderFns } from "./AppViewContainer.vue?vue&type=template&id=5a1b50c6&scoped=true"
import script from "./AppViewContainer.vue?vue&type=script&lang=js"
export * from "./AppViewContainer.vue?vue&type=script&lang=js"
import style0 from "./AppViewContainer.vue?vue&type=style&index=0&id=5a1b50c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b50c6",
  null
  
)

export default component.exports